var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClanTree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 16.4542,
    y2: -0.5,
    transform: "matrix(-0.497837 0.86727 -0.860217 -0.509928 27.916 9.75684)",
    stroke: "#1D1D1F"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 14.4402,
    y2: -0.5,
    transform: "matrix(-0.567274 0.823529 -0.814864 -0.579652 19.7236 24.0269)",
    stroke: "#1D1D1F"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 11.8239,
    y2: -0.5,
    transform: "matrix(0.593821 -0.804597 0.795334 0.606171 4.51025 45.4324)",
    stroke: "#1D1D1F"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 11.0312,
    y1: 45.4324,
    x2: 11.0312,
    y2: 35.9189,
    stroke: "#1D1D1F"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 10.6027,
    y2: -0.5,
    transform: "matrix(0.441479 -0.897272 0.891518 0.452985 18.5532 45.4324)",
    stroke: "#1D1D1F"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 9.79717,
    y2: -0.5,
    transform: "matrix(-0.238889 -0.971047 0.969211 -0.246231 25.5742 45.4324)",
    stroke: "#1D1D1F"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 11.8239,
    y2: -0.5,
    transform: "matrix(-0.593821 -0.804597 -0.795334 0.606171 52.4902 45.4324)",
    stroke: "#1D1D1F"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 9.51351,
    y2: -0.5,
    transform: "matrix(4.10577e-08 -1 -1 -4.23997e-08 45.4688 45.4324)",
    stroke: "#1D1D1F"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 10.6027,
    y2: -0.5,
    transform: "matrix(-0.441479 -0.897272 -0.891518 0.452985 38.4478 45.4324)",
    stroke: "#1D1D1F"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 9.79717,
    y2: -0.5,
    transform: "matrix(0.238889 -0.971047 -0.969211 -0.246231 31.4268 45.4324)",
    stroke: "#1D1D1F"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 12.12,
    y2: -0.5,
    transform: "matrix(0.193105 0.981178 -0.979965 0.19917 19.7236 24.0269)",
    stroke: "#1D1D1F"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 14.4402,
    y2: -0.5,
    transform: "matrix(0.567274 0.823529 0.814864 -0.579652 37.2773 24.0269)",
    stroke: "#1D1D1F"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 12.12,
    y2: -0.5,
    transform: "matrix(-0.193105 0.981178 0.979965 0.19917 37.2773 24.0269)",
    stroke: "#1D1D1F"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 16.4542,
    y2: -0.5,
    transform: "matrix(0.497837 0.867271 -0.860217 0.509928 27.916 9.75684)",
    stroke: "#1D1D1F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.389 10.633C33.389 13.4755 31.1236 15.766 28.3459 15.766C25.5682 15.766 23.3027 13.4755 23.3027 10.633C23.3027 7.79051 25.5682 5.5 28.3459 5.5C31.1236 5.5 33.389 7.79051 33.389 10.633Z",
    stroke: "#1D1D1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1507 23.7769C24.1507 26.1009 22.2989 27.9711 20.0314 27.9711C17.7639 27.9711 15.9121 26.1009 15.9121 23.7769C15.9121 21.4529 17.7639 19.5828 20.0314 19.5828C22.2989 19.5828 24.1507 21.4529 24.1507 23.7769Z",
    stroke: "#1D1D1F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9978 35.9819C25.9978 37.7874 24.5596 39.2372 22.8024 39.2372C21.0451 39.2372 19.6069 37.7874 19.6069 35.9819C19.6069 34.1764 21.0451 32.7266 22.8024 32.7266C24.5596 32.7266 25.9978 34.1764 25.9978 35.9819Z",
    stroke: "#1D1D1F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0837 35.9819C37.0837 37.7874 35.6455 39.2372 33.8883 39.2372C32.1311 39.2372 30.6929 37.7874 30.6929 35.9819C30.6929 34.1764 32.1311 32.7266 33.8883 32.7266C35.6455 32.7266 37.0837 34.1764 37.0837 35.9819Z",
    stroke: "#1D1D1F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1716 35.9819C48.1716 37.7874 46.7334 39.2372 44.9762 39.2372C43.219 39.2372 41.7808 37.7874 41.7808 35.9819C41.7808 34.1764 43.219 32.7266 44.9762 32.7266C46.7334 32.7266 48.1716 34.1764 48.1716 35.9819Z",
    stroke: "#1D1D1F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9118 35.9819C14.9118 37.7874 13.4737 39.2372 11.7164 39.2372C9.95919 39.2372 8.521 37.7874 8.521 35.9819C8.521 34.1764 9.95919 32.7266 11.7164 32.7266C13.4737 32.7266 14.9118 34.1764 14.9118 35.9819Z",
    stroke: "#1D1D1F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.35109 46.0268C6.35109 47.4002 5.25759 48.4998 3.92555 48.4998C2.5935 48.4998 1.5 47.4002 1.5 46.0268C1.5 44.6534 2.5935 43.5538 3.92555 43.5538C5.25759 43.5538 6.35109 44.6534 6.35109 46.0268Z",
    stroke: "#1D1D1F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3721 46.0267C13.3721 47.4001 12.2786 48.4997 10.9465 48.4997C9.6145 48.4997 8.521 47.4001 8.521 46.0267C8.521 44.6533 9.6145 43.5537 10.9465 43.5537C12.2786 43.5537 13.3721 44.6533 13.3721 46.0267Z",
    stroke: "#1D1D1F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3941 46.0267C20.3941 47.4001 19.3006 48.4997 17.9685 48.4997C16.6365 48.4997 15.543 47.4001 15.543 46.0267C15.543 44.6533 16.6365 43.5537 17.9685 43.5537C19.3006 43.5537 20.3941 44.6533 20.3941 46.0267Z",
    stroke: "#1D1D1F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4151 46.0267C27.4151 47.4001 26.3216 48.4997 24.9895 48.4997C23.6575 48.4997 22.564 47.4001 22.564 46.0267C22.564 44.6533 23.6575 43.5537 24.9895 43.5537C26.3216 43.5537 27.4151 44.6533 27.4151 46.0267Z",
    stroke: "#1D1D1F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4361 46.0267C34.4361 47.4001 33.3425 48.4997 32.0105 48.4997C30.6785 48.4997 29.585 47.4001 29.585 46.0267C29.585 44.6533 30.6785 43.5537 32.0105 43.5537C33.3425 43.5537 34.4361 44.6533 34.4361 46.0267Z",
    stroke: "#1D1D1F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4566 46.0267C41.4566 47.4001 40.3631 48.4997 39.031 48.4997C37.699 48.4997 36.6055 47.4001 36.6055 46.0267C36.6055 44.6533 37.699 43.5537 39.031 43.5537C40.3631 43.5537 41.4566 44.6533 41.4566 46.0267Z",
    stroke: "#1D1D1F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4785 46.0267C48.4785 47.4001 47.385 48.4997 46.053 48.4997C44.7209 48.4997 43.6274 47.4001 43.6274 46.0267C43.6274 44.6533 44.7209 43.5537 46.053 43.5537C47.385 43.5537 48.4785 44.6533 48.4785 46.0267Z",
    stroke: "#1D1D1F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4995 46.0267C55.4995 47.4001 54.406 48.4997 53.074 48.4997C51.7419 48.4997 50.6484 47.4001 50.6484 46.0267C50.6484 44.6533 51.7419 43.5537 53.074 43.5537C54.406 43.5537 55.4995 44.6533 55.4995 46.0267Z",
    stroke: "#1D1D1F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7801 23.7769C40.7801 26.1009 38.9283 27.9711 36.6608 27.9711C34.3933 27.9711 32.5415 26.1009 32.5415 23.7769C32.5415 21.4529 34.3933 19.5828 36.6608 19.5828C38.9283 19.5828 40.7801 21.4529 40.7801 23.7769Z",
    stroke: "#1D1D1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClanTree);
export default __webpack_public_path__ + "static/media/clan-tree.9fbe7f0d639eebd92352be4a6cc94db1.svg";
export { ForwardRef as ReactComponent };